export { useSegmentConfiguration } from './use-segment-configuration';